import { render, staticRenderFns } from "./AddEditOnBoardingQuestionnaire.vue?vue&type=template&id=e8559eec&scoped=true&"
import script from "./AddEditOnBoardingQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./AddEditOnBoardingQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./AddEditOnBoardingQuestionnaire.vue?vue&type=style&index=0&id=e8559eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8559eec",
  null
  
)

export default component.exports